import API from './API';

class DirectoryLegalFromsAPI extends API {
  constructor(parameters = {}) {
    super('/DirectoryLegalForms', parameters);
  }
}

export default DirectoryLegalFromsAPI;
